"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledIcon = _styledComponents.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: ", ";\n  margin: ", ";\n  color: ", ";\n"])), function (props) {
  return props.size || "inherit";
}, function (props) {
  return props.margin;
}, function (props) {
  return props.color;
});

var MatIcon = function MatIcon(_ref) {
  var children = _ref.children,
      size = _ref.size,
      margin = _ref.margin,
      color = _ref.color,
      className = _ref.className;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIcon, {
    size: size,
    margin: margin,
    color: color,
    className: "material-icons ".concat(className),
    children: children
  });
};

MatIcon.defaultProps = {
  size: "24px",
  margin: "0",
  color: "inherit"
};
MatIcon.propTypes = {
  size: _propTypes.default.string,
  margin: _propTypes.default.string,
  color: _propTypes.default.string
};
var _default = MatIcon;
exports.default = _default;